var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-card-wrapper"},[_c('b-card',{attrs:{"header":"true","header-tag":"header"}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center",attrs:{"slot":"header"},slot:"header"},[_c('p',{staticClass:"mb-0 d-inline-block align-middle"},[_c('b',[_vm._v("Informazioni")])])]),_vm._v(" "),_c('div',{staticClass:"details-card custom-grid-wrapper"},[_vm._l((_vm.fields),function(field,index){return [_c('div',{key:`if_1_${index}`,class:{
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            'grid-item-label': true,
          }},[_c('strong',[_vm._v(_vm._s(field.label.toUpperCase()))])]),_vm._v(" "),_c('div',{key:`else_1_${index}`,class:{
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            'grid-item-value': true,
          }},[_vm._v("\n          "+_vm._s(_vm.renderDbRowData(field, _vm.dbRowData))+"\n        ")])]})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }